import { Button, Chip, Grid, IconButton, InputAdornment, Stack, TextField } from "src/components"
import MaskedTextField from "src/components/MaskedTextField"
import TabContext from "src/components/TabContext"
import TabPanel from "src/components/TabPanel"
import BaseComponent from "src/core/base.component"
import LbysCptch from "./LbysCptch"
import SmsOnayForm from "src/parts/Genel/SmsOnayForm"
import SifreDegistirForm from "./SifreDegistirForm"
import { useAppDispatch, useAppSelector } from "src/store"
import { authApi, useLazyLoginQuery, useLazyLoginSmsQuery, useLazyYeniSifreVerildiQuery } from "src/services/Auth/AuthApi"
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import ChangeCircleIcon from '@mui/icons-material/ChangeCircle';
import AuthSlice, { IUserState } from "src/store/slices/Auth/AuthSlice"
import { helper } from "src/utils/helper"
import CommonSlice from "src/store/slices/CommonSlice"
import { useState } from "react"
import { useTranslation } from "react-i18next"

import PasswordIcon from '@mui/icons-material/Password';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import SnackbarUtils from "src/utils/SnackbarUtils"

const KullaniciGirisi = (): JSX.Element => {
    const userState = useAppSelector(s => s.userLogin)
    const [query, queryState] = useLazyLoginQuery();
    const dispatch = useAppDispatch();
    const {t} = useTranslation();
    const handleUsername = (userName: string) => {
        dispatch(AuthSlice.actions.setLoginkod(userName))
        if (!helper.tcKimlikMantiksalDogrulama(userName) && userName?.length === 11) {
            dispatch(AuthSlice.actions.setState({
                ...userState,
                Loginkod: userName,
                loginKodError: t('pages|login|gecersizTC', "Giriş Bilgileriniz Hatalı")
            }))
            return;
        }
        // else if (userName?.length === 11) {
        //     queryYeniSifre({
        //         username: userName
        //     })
        //         .unwrap()
        //         .then(res => {
        //             dispatch(AuthSlice.actions.setState({
        //                 ...userState,
        //                 Loginkod: userName,
        //                 loginKodError: "",
        //                 tabValue: res.yeniSifreVerildi ? "2" : "1",
        //                 gsmNo: res.gsmNo
        //             }))
        //         })
        //         .catch(e => e)
        // }
        else dispatch(AuthSlice.actions.setState({
            ...userState,
            Loginkod: userName,
            loginKodError: ""
        }))
    };
    const handleUsernameChange: React.ChangeEventHandler<HTMLInputElement> = (
        event
    ) => {
        handleUsername(event.target.value)
    };

    const handleKeyPress = (event: React.KeyboardEvent) => {
        if (event.keyCode === 13 || event.which === 13) {
            userState.isButtonDisabled || handleLogin(event);
        }
    };
    const handleLogin = (e: any) => {
        if (userState.hataSayi > 1 && !userState.captchaKodu) {
            dispatch(AuthSlice.actions.setState({
                ...userState,
                captchaHelpertext: t('pages|login|captcha', "Güvenlik Kodu Boş Geçilemez")
            }))
            return;
        }
        query({
            username: userState.Loginkod,
            password: userState.Password,
            captchaCode: userState.captchaKodu,
            captchaId: userState.captchaId
        })
            .unwrap()
            .then(res => {
                if(res.yenisifreverildi === "H")
                {
                    dispatch(AuthSlice.actions.setState({
                        ...userState,
                        isButtonDisabled: true,
                        userInfo:{...res,
                            tcKimlikNo: helper.decrypt2(res.tcKimlikNo),
                            gsm_No: helper.decrypt2(res.tcKimlikNo),
                            eposta: helper.decrypt2(res.eposta),
                            kullaniciKodu: helper.decrypt2(res.kullaniciKodu)
                        },
                        isLoggedIn: res.kullaniciId > 0,
                        captchaKodu: "",
                        hataSayi: 0,
                        captchaHelpertext: "",
                        captchaId: null
                    }))
                }
                else {
                    SnackbarUtils.info("Şifre değişikliğine yönlendirildiniz!")
                    dispatch(AuthSlice.actions.setState({
                        ...userState,
                        tabValue: "2"
                    }))
                }
            })
            .catch(e => {

                if (e?.code !== 401) {
                    dispatch(authApi.util.invalidateTags(["CaptchaImage"]))
                    return;
                }
                const _state: IUserState = {
                    ...userState,
                    hataSayi: userState.hataSayi + 1
                }
                if (_state.hataSayi === 3)
                    _state.tabValue = "2"
                else if (_state.hataSayi === 4) {
                    dispatch(CommonSlice.actions.logOut("client"))
                    return;
                }
                dispatch(AuthSlice.actions.setState(_state))
            })
    };


    const [passValues, setPasValues] = useState({
        amount: '',
        password: '',
        weight: '',
        weightRange: '',
        showPassword: false
    });

    const handleClickShowPassword = () => {
        setPasValues({
            ...passValues,
            showPassword: !passValues.showPassword
        });
    };

    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };
    const handlePasswordChange: React.ChangeEventHandler<HTMLInputElement> = (
        event
    ) => {
        dispatch(AuthSlice.actions.setState({
            ...userState,
            Password: event.target.value,
        }))
    };
    const [loginSms, loginSmsQuery] = useLazyLoginSmsQuery();

    return (
        <TabContext value={userState.tabValue}>
            {/* <TabPanel value="0" hideBorder={true}>
                <BaseComponent
                    loading={queryYeniSifreState.isFetching}
                >
                    <MaskedTextField
                        autoFocus
                        error={queryYeniSifreState.isError || Boolean(userState.loginKodError)}
                        size="medium"
                        value={userState.Loginkod}
                        fullWidth
                        mask={"00000000000"}
                        id="Username"
                        label={t('pages|login|tcKimlikNo', 'T.C Kimlik No')}
                        placeholder={t(
                            'pages|login|tcKimlikNoGirin',
                            'T.C Kimlik No Giriniz...'
                        )}
                        inputProps={{ maxLength: 11 }}
                        onChange={handleUsernameChange}
                        onKeyPress={handleKeyPress}
                        helperText={queryYeniSifreState.error?.message || userState.loginKodError}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <AccountCircleIcon />
                                </InputAdornment>
                            ),
                            // endAdornment: (
                            //     <InputAdornment position="end">
                            //         <IconButton
                            //             size="medium"
                            //             customType="next"
                            //             onClick={(e) => {
                            //                 handleUsername(userState.Loginkod)
                            //             }}
                            //         />
                            //     </InputAdornment>
                            // )
                        }}
                    />
                </BaseComponent>
            </TabPanel> */}
            <TabPanel value={"0"} hideBorder={true}>
                <Grid container>
                    <Grid item xs={12} sm={12}>
                    <BaseComponent
                    loading={queryState.isFetching}
                >
                    <MaskedTextField
                        autoFocus
                        error={queryState.isError}
                        size="medium"
                        value={userState.Loginkod}
                        fullWidth
                        mask={"00000000000"}
                        id="Username"
                        label={t('pages|login|tcKimlikNo', 'T.C Kimlik No')}
                        placeholder={t(
                            'pages|login|tcKimlikNoGirin',
                            'T.C Kimlik No Giriniz...'
                        )}
                        inputProps={{ maxLength: 11 }}
                        onChange={handleUsernameChange}
                        onKeyPress={handleKeyPress}
                        helperText={queryState.error?.message || userState.loginKodError}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <AccountCircleIcon />
                                </InputAdornment>
                            ),
                            // endAdornment: (
                            //     <InputAdornment position="end">
                            //         <IconButton
                            //             size="medium"
                            //             customType="next"
                            //             onClick={(e) => {
                            //                 handleUsername(userState.Loginkod)
                            //             }}
                            //         />
                            //     </InputAdornment>
                            // )
                        }}
                    />
                </BaseComponent>
                    </Grid>
                    <Grid item xs={12}>
                        <TextField                            
                            error={queryState.isError}
                            fullWidth
                            id="Password"
                            size="medium"
                            value={userState.Password}
                            type={passValues.showPassword ? 'text' : 'password'}
                            label={t('pages|login|password', 'Şifre')}
                            placeholder={t('pages|login|password', 'Şifre')}
                            helperText={queryState.isError && queryState.error?.message}
                            onChange={handlePasswordChange}
                            onKeyPress={handleKeyPress}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <PasswordIcon />
                                    </InputAdornment>
                                ),
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <IconButton
                                            aria-label="toggle password visibility"
                                            size="medium"
                                            onClick={handleClickShowPassword}
                                            onMouseDown={handleMouseDownPassword}
                                            edge="end"
                                        >
                                            {passValues.showPassword ? (
                                                <VisibilityOffIcon />
                                            ) : (
                                                <VisibilityIcon />
                                            )}
                                        </IconButton>
                                    </InputAdornment>
                                )
                            }}
                        ></TextField>
                    </Grid>
                    <Grid item xs={12}>
                        <Grid container justifyContent={"left"}>
                            <Grid item md={6}>
                                <Button
                                    variant="text"
                                    sx={{ textAlign: "left" }}
                                    onClick={(e) => {
                                        dispatch(AuthSlice.actions.setState({
                                            ...userState,
                                            tabValue: "2"
                                        }))
                                    }}>
                                    {t('pages|login|sifremiUnuttum', 'Şifremi Unuttum')}

                                </Button>
                            </Grid>
                        </Grid>
                    </Grid>
                    {userState.hataSayi > 1 && <Grid item>
                        <LbysCptch></LbysCptch>
                    </Grid>}
                    <Grid item xs={12}>
                        <Button
                            onClick={handleLogin}
                            size="large"
                            disabled={userState.isButtonDisabled}
                            loading={queryState.isFetching}
                        >
                            {t('pages|login|signin', 'Giriş Yap')}
                        </Button>
                    </Grid>
                </Grid>
            </TabPanel>
            <TabPanel value={"2"} hideBorder={true}>                
                <SmsOnayForm
                    open={userState.tabValue === "2" ? true : false}
                    telno={userState.gsmNo}
                    onClosed={() => {
                        dispatch(CommonSlice.actions.logOut("client"))
                    }}
                    onSelected={(o, m, kod, tckNo) => {
                        if (userState.hataSayi === 3) {
                            dispatch(AuthSlice.actions.setState({
                                ...userState,
                                tabValue: "1",

                            }))
                            return;
                        }
                        loginSms({
                            username: tckNo,
                            onayKodu: kod
                        })
                            .unwrap()
                            .then(res => {
                                dispatch(AuthSlice.actions.setState({
                                    ...userState,
                                    tabValue: "3",
                                    userInfo: res
                                }))
                            })
                            .catch(e => e)
                    }}
                />
            </TabPanel>
            <TabPanel value={"3"} hideBorder={true}>
                <SifreDegistirForm
                    onClose={() => {
                        dispatch(AuthSlice.actions.setState({
                            ...userState,
                            tabValue: "0",
                            Loginkod: ""
                        }))
                    }}
                    onChanged={() => {
                        const _state = {
                            ...userState,
                            isButtonDisabled: true,
                            isLoggedIn: true
                        }
                        dispatch(AuthSlice.actions.setState(_state))
                        sessionStorage.setItem('userLogin', helper.encrypt(JSON.stringify(_state)))
                    }}
                />
            </TabPanel>
        </TabContext>
    )

}
export default KullaniciGirisi;